import './MenuItems.css';

function MenuItems(props) {
  const { item, openItem, reports } = props;

  let title = <div className="menuItems_title">{item.title}</div>;
  let itemsArray = item.items.map((itemElement) => {
    const elementStyle = [itemElement.icon, 'item_icon'].join(' ');
    if (itemElement.document === false) {
      return (
        <li
          style={{ margin: '10px 0', cursor: 'pointer' }}
          key={itemElement.type}
          onClick={() => openItem(itemElement)}
          className="menuItem"
        >
          <i className={elementStyle} />
          <span
            className="item_title"
            style={itemElement.title.length > 20 ? { fontSize: '11px' } : {}}
          >
            {itemElement.title}
          </span>
        </li>
      );
    }
    return null;
  });

  if (reports) {
    title = null;
    itemsArray = item.items.map((item) => {
      const elementStyle = [item.icon, 'item_icon'].join(' ');
      if (item.document) {
        return (
          <li
            style={{ margin: '10px 0', cursor: 'pointer' }}
            key={item.type}
            onClick={() => openItem(item)}
            className="menuItem report"
          >
            <i className={elementStyle} />
            <span className="item_title">{item.title}</span>
          </li>
        );
      }
      return null;
    });
  }
  return (
    <div key={item.title} className="menuItems_container">
      {title}
      <ul>{itemsArray}</ul>
    </div>
  );
}

export default MenuItems;
